export default class NotesTrackerElement {
  constructor(view) {
    this.view = view;
    this.dom = document.createElement("ul");
    this.dom.className = "editor-note-tracker";
    this.parentElement = this.view.dom.closest("richtext-editor");

    this.authorNotesListItem = document.createElement("li");
    this.authorNotesListItem.setAttribute("hidden", "");
    this.editorNotesListItem = document.createElement("li");
    this.editorNotesListItem.setAttribute("hidden", "");

    this.dom.appendChild(this.authorNotesListItem);
    this.dom.appendChild(this.editorNotesListItem);

    this.parentElement.insertBefore(this.dom, this.parentElement.lastElementChild.nextSibling);

    this.update(view);
  }

  update(view) {
    const { notesCount, notesDescriptionCount } = this.scanNotes();

    if(notesCount.autor !== notesDescriptionCount.autor) {
      this.authorNotesListItem.textContent = "Hay una discrepancia entre la cantidad de notas de autor indicadas en la obra y las descripciones señaladas para las mismas. Verifique para eliminar este mensaje.";
      this.authorNotesListItem.removeAttribute("hidden");
    } else {
      this.authorNotesListItem.textContent = "";
      this.authorNotesListItem.setAttribute("hidden", "");
    }

    if(notesCount.editor !== notesDescriptionCount.editor) {
      this.editorNotesListItem.textContent = "Hay una discrepancia entre la cantidad de notas de editor indicadas en la obra y las descripciones señaladas para las mismas. Verifique para eliminar este mensaje.";
      this.editorNotesListItem.removeAttribute("hidden");
    } else {
      this.editorNotesListItem.textContent = "";
      this.editorNotesListItem.setAttribute("hidden", "");
    }
  }

  destroy() {
    this.view = null;
    this.dom = null;
  }

  scanNotes() {
    const notesCount = { autor: 0, editor: 0 },
      notesDescriptionCount = { autor: 0, editor: 0 };
    let itemType;
    this.view.state.tr.doc.descendants((node, pos) => {
      if(node.type.name === "note") {
        itemType = node.attrs.type;
        notesCount[itemType] += 1;
      } else if(node.type.name === "listItem") {
        if(!!node.attrs?.id) {
          itemType = node.attrs.id.split("-")[1];
          notesDescriptionCount[itemType] += 1;
        }
      }
    });

    return { notesCount, notesDescriptionCount };
  }
}
